<div class="ov column" (click)="openDetailsModal()">
  {{ item.number || '---' }}
</div>
<div class="timestamp column" (click)="openDetailsModal()">
  {{ date || '---' }}
</div>
<div class="products column" (click)="openDetailsModal()">
  <div class="product" *ngFor="let p of item.products" [matTooltip]="p.name">{{ p.name || '---' }}</div>
</div>
<div class="quantity column" (click)="openDetailsModal()">
  <div *ngFor="let p of item.products">{{ p.quantity.required || '---' }}</div>
</div>
<div class="status column" (click)="openDetailsModal()">
  {{ translateStatus(item.status) }}
</div>
<div class="buttons column">
  <button mat-raised-button class="primary-2 fake-nfe"
          (click)="emulateNfe(item)">
    FAKE NFE
  </button>
  <button mat-raised-button class="secondary-2 alert-btn" (click)="goToReport(item)"
    *ngIf="item.status === statusEnum.BLOCKED_TO_DISPATCH">
    Analisar Relatório
  </button>
  <button mat-raised-button class="primary-2" (click)="createInventory(item)"
    *ngIf="item.status === statusEnum.AWAITING_VALIDATION || item.status === statusEnum.BLOCKED_TO_DISPATCH">
    Enviar Inventário
  </button>
</div>